import { render } from "./MfittSelectPaymentMethod.vue?vue&type=template&id=45f38266"
import script from "./MfittSelectPaymentMethod.vue?vue&type=script&lang=js"
export * from "./MfittSelectPaymentMethod.vue?vue&type=script&lang=js"
script.render = render

export default script